// import { useState, useEffect, useRef } from "react";
// import { Link } from "react-router-dom";
// import { supabase } from "../lib/supabaseClient.ts";

// const NewArrivals = () => {
//   const [isMobile, setIsMobile] = useState(false);
//   const [arrivals, setArrivals] = useState([]);
//   const [sectionMeta, setSectionMeta] = useState(null);
//   const carouselRef = useRef(null);
//   const [currentPage, setCurrentPage] = useState(0);

//   const COLS = 5;
//   const ROWS = 4;
//   const PER_PAGE = COLS * ROWS; // 20 cards per page

//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth <= 768);
//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     const fetchArrivals = async () => {
//       const { data: section, error: error1 } = await supabase
//         .from("arrivals_section")
//         .select("*")
//         .maybeSingle();

//       const { data: products, error: error2 } = await supabase
//         .from("products")
//         .select("*")
//         .eq("new", true);

//       if (!error1 && section) setSectionMeta(section);
//       if (!error2 && products) setArrivals(products);
//     };
//     fetchArrivals();
//   }, []);

//   const promoIds = arrivals.filter((p) => p.is_promo).map((p) => p.id);

//   const filteredProducts = arrivals.filter(
//     (product) => product.price_range && !product.price_range.includes("–")
//   );

//   const totalPages = Math.ceil(filteredProducts.length / PER_PAGE);
//   const currentProducts = filteredProducts.slice(
//     currentPage * PER_PAGE,
//     (currentPage + 1) * PER_PAGE
//   );

//   const goTo = (page) => {
//     const p = Math.min(Math.max(page, 0), totalPages - 1);
//     setCurrentPage(p);
//     window.scrollTo({
//       top: (carouselRef.current?.offsetTop || 200) - 100,
//       behavior: "smooth",
//     });
//   };

//   const formatPrice = (price_range) =>
//     new Intl.NumberFormat("fr-FR", {
//       minimumFractionDigits: 3,
//       maximumFractionDigits: 3,
//     }).format(parseFloat(price_range));

//   return (
//     <section className="new-arrivals py-5">
//       <style>{`
//         /* ── Desktop grid ── */
//         .na-grid {
//           display: grid;
//           grid-template-columns: repeat(5, 1fr);
//           gap: 16px;
//           width: 100%;
//         }
//         @media (max-width: 1100px) {
//           .na-grid { grid-template-columns: repeat(4, 1fr); }
//         }

//         /* ── Shared card ── */
//         .na-card {
//           background: #F4F1EA;
//           border-radius: 12px;
//           padding: 10px;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           transition: transform 0.2s ease, box-shadow 0.2s ease;
//           text-decoration: none;
//           min-height: 220px;
//         }
//         .na-card:hover {
//           transform: translateY(-3px);
//           box-shadow: 0 6px 20px rgba(0,0,0,0.12);
//         }

//         /* ── Shared image wrap ── */
//         .na-img-wrap {
//           width: 100%;
//           height: 130px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           position: relative;
//           overflow: hidden;
//           border-radius: 8px;
//           background: #fff;
//         }
//         .na-img-wrap img {
//           max-width: 90%;
//           max-height: 120px;
//           object-fit: contain;
//           display: block;
//           margin: 0 auto;
//         }

//         /* ── Promo badge ── */
//         .na-promo-badge {
//           position: absolute;
//           top: 6px;
//           right: 6px;
//           background: #28a745;
//           color: #fff;
//           font-size: 0.6rem;
//           font-weight: 700;
//           padding: 2px 6px;
//           border-radius: 8px;
//         }

//         /* ── Card body ── */
//         .na-body {
//           width: 100%;
//           text-align: center;
//           margin-top: 8px;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           gap: 4px;
//           flex: 1;
//         }
//         .na-name {
//           font-size: 0.78rem;
//           font-weight: 600;
//           color: #222;
//           line-height: 1.3;
//           margin: 0;
//           word-break: break-word;
//         }
//         .na-price {
//           font-size: 0.88rem;
//           color: #ff41b4;
//           font-weight: 700;
//           margin: 0;
//         }

//         /* ── Arrows ── */
//         .na-arrow {
//           position: absolute;
//           top: 45%;
//           transform: translateY(-50%);
//           z-index: 10;
//           background: #ff41b4;
//           color: white;
//           border: none;
//           border-radius: 50%;
//           width: 36px;
//           height: 36px;
//           font-size: 20px;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           box-shadow: 0 2px 8px rgba(0,0,0,0.15);
//           transition: background 0.2s;
//         }
//         .na-arrow:disabled {
//           background: #ccc;
//           cursor: default;
//         }

//         /* ── Dots ── */
//         .na-dots {
//           display: flex;
//           justify-content: center;
//           gap: 8px;
//           margin-top: 24px;
//         }
//         .na-dot {
//           height: 8px;
//           border-radius: 4px;
//           border: none;
//           cursor: pointer;
//           padding: 0;
//           transition: all 0.3s ease;
//           background: #ccc;
//         }
//         .na-dot.active {
//           width: 24px !important;
//           background: #ff41b4;
//         }

//         /* ── Mobile horizontal scroll ── */
//         .na-mobile-scroll {
//           display: flex;
//           flex-direction: row;
//           overflow-x: auto;
//           gap: 10px;
//           scroll-snap-type: x mandatory;
//           padding: 0 8px 8px;
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//         }
//         .na-mobile-scroll::-webkit-scrollbar { display: none; }

//         /* ── Mobile card ── */
//         .na-mobile-card {
//           scroll-snap-align: start;
//           flex: 0 0 44%;
//           background: #F4F1EA;
//           border-radius: 12px;
//           padding: 10px;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           min-height: 200px;
//           text-decoration: none;
//         }

//         /* ── Mobile image wrap — explicit centering ── */
//         .na-mobile-card .na-img-wrap {
//           width: 100%;
//           height: 120px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           background: #fff;
//           border-radius: 8px;
//           overflow: hidden;
//           position: relative;
//         }
//         .na-mobile-card .na-img-wrap img {
//           max-width: 85%;
//           max-height: 105px;
//           object-fit: contain;
//           display: block;
//   margin-left: 190px;
//         }
//       `}</style>

//       <div className="container">
//         {/* Section header */}
//         <div className="row justify-content-center">
//           <div className="col-xl-7 col-lg-9">
//             <div className="section-title text-center mb-65">
//               <h5
//                 className="sub-title"
//                 style={{ fontSize: isMobile ? "16px" : "34px" }}
//               >
//                 {sectionMeta?.subtitle || "New Arrivals"}
//               </h5>
//               <p
//                 style={{
//                   fontSize: isMobile ? "12px" : "14px",
//                   textAlign: "center",
//                   maxWidth: "500px",
//                   margin: "auto",
//                   lineHeight: "1.5",
//                 }}
//               >
//                 {sectionMeta?.description ||
//                   "Explorez les derniers produits ajoutés à notre boutique."}
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* ── DESKTOP ── */}
//         {!isMobile && (
//           <div ref={carouselRef} style={{ position: "relative", padding: "0 48px" }}>
//             {/* Left arrow */}
//             <button
//               className="na-arrow"
//               style={{ left: 0 }}
//               onClick={() => goTo(currentPage - 1)}
//               disabled={currentPage === 0}
//             >
//               ‹
//             </button>

//             {/* Grid */}
//             <div className="na-grid">
//               {currentProducts.map((product) => (
//                 <Link
//                   key={product.id}
//                   to={`/shop-details/${product.id}`}
//                   className="na-card"
//                 >
//                   <div className="na-img-wrap">
//                     <img src={product.image} alt={product.name} />
//                     {promoIds.includes(product.id) && (
//                       <span className="na-promo-badge">Promo!</span>
//                     )}
//                   </div>
//                   <div className="na-body">
//                     <p className="na-name">
//                       {product.name.length > 22
//                         ? product.name.substring(0, 22) + "…"
//                         : product.name}
//                     </p>
//                     {product.price_range && (
//                       <p className="na-price">
//                         {formatPrice(product.price_range)} DT
//                       </p>
//                     )}
//                   </div>
//                 </Link>
//               ))}
//             </div>

//             {/* Right arrow */}
//             <button
//               className="na-arrow"
//               style={{ right: 0 }}
//               onClick={() => goTo(currentPage + 1)}
//               disabled={currentPage >= totalPages - 1}
//             >
//               ›
//             </button>

//             {/* Dots */}
//             {totalPages > 1 && (
//               <div className="na-dots">
//                 {Array.from({ length: totalPages }).map((_, i) => (
//                   <button
//                     key={i}
//                     className={`na-dot${i === currentPage ? " active" : ""}`}
//                     style={{ width: i === currentPage ? "24px" : "8px" }}
//                     onClick={() => goTo(i)}
//                   />
//                 ))}
//               </div>
//             )}
//           </div>
//         )}

//         {/* ── MOBILE horizontal scroll ── */}
//         {isMobile && (
//           <div className="na-mobile-scroll">
//             {filteredProducts.map((product) => (
//               <Link
//                 key={product.id}
//                 to={`/shop-details/${product.id}`}
//                 className="na-mobile-card"
//               >
//                 <div className="na-img-wrap">
//                   <img src={product.image} alt={product.name} />
//                   {promoIds.includes(product.id) && (
//                     <span className="na-promo-badge">Promo!</span>
//                   )}
//                 </div>
//                 <div className="na-body">
//                   <p className="na-name">
//                     {product.name.length > 18
//                       ? product.name.substring(0, 18) + "…"
//                       : product.name}
//                   </p>
//                   {product.price_range && (
//                     <p className="na-price">
//                       {formatPrice(product.price_range)} DT
//                     </p>
//                   )}
//                 </div>
//               </Link>
//             ))}
//           </div>
//         )}
//       </div>
//     </section>
//   );
// };

// export default NewArrivals;
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../lib/supabaseClient.ts";

const NewArrivals = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [arrivals, setArrivals] = useState([]);
  const [sectionMeta, setSectionMeta] = useState(null);
  const carouselRef = useRef(null);
  const mobileRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [mobileCurrentPage, setMobileCurrentPage] = useState(0);

  const COLS = 5;
  const ROWS = 4;
  const PER_PAGE = COLS * ROWS;

  const MOBILE_COLS = 2;
  const MOBILE_ROWS = 4;
  const MOBILE_PER_PAGE = MOBILE_COLS * MOBILE_ROWS;

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchArrivals = async () => {
      const { data: section, error: error1 } = await supabase
        .from("arrivals_section").select("*").maybeSingle();
      const { data: products, error: error2 } = await supabase
        .from("products").select("*").eq("new", true);
      if (!error1 && section) setSectionMeta(section);
      if (!error2 && products) setArrivals(products);
    };
    fetchArrivals();
  }, []);

  const filteredProducts = arrivals.filter(
    (product) => product.price_range && !product.price_range.includes("–")
  );

  // Desktop pagination
  const totalPages = Math.ceil(filteredProducts.length / PER_PAGE);
  const currentProducts = filteredProducts.slice(
    currentPage * PER_PAGE,
    (currentPage + 1) * PER_PAGE
  );

  // Mobile pagination
  const mobileTotalPages = Math.ceil(filteredProducts.length / MOBILE_PER_PAGE);
  const mobileCurrentProducts = filteredProducts.slice(
    mobileCurrentPage * MOBILE_PER_PAGE,
    (mobileCurrentPage + 1) * MOBILE_PER_PAGE
  );

  const goTo = (page) => {
    const p = Math.min(Math.max(page, 0), totalPages - 1);
    setCurrentPage(p);
    window.scrollTo({
      top: (carouselRef.current?.offsetTop || 200) - 100,
      behavior: "smooth",
    });
  };

  const goToMobile = (page) => {
    const p = Math.min(Math.max(page, 0), mobileTotalPages - 1);
    setMobileCurrentPage(p);
    window.scrollTo({
      top: (mobileRef.current?.offsetTop || 200) - 80,
      behavior: "smooth",
    });
  };

  // ─── Price helpers ────────────────────────────────────────────────────────────
  const fmt = (n) => {
    if (n == null || isNaN(n)) return 'Prix indisponible';
    return new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    }).format(n);
  };

  const parsePrice = (val) => {
    if (val == null) return NaN;
    return parseFloat(String(val).replace(',', '.'));
  };

  const renderPrice = (product) => {
    const priceRangeRaw = parsePrice(product.price_range);
    const oldPriceRaw = parsePrice(product.old_price);

    if (!product.promo) {
      return isNaN(priceRangeRaw) ? null : (
        <p className="na-price">{fmt(priceRangeRaw)} DT</p>
      );
    }

    const promoType = product.promo_type || 'percentage';
    const pct = product.promo_percentage || 0;

    let finalPrice, oldPrice;

    if (promoType === 'exact') {
      oldPrice = isNaN(oldPriceRaw) ? null : oldPriceRaw;
      finalPrice = isNaN(priceRangeRaw) ? null : priceRangeRaw;
    } else {
      const base = !isNaN(oldPriceRaw) ? oldPriceRaw : priceRangeRaw;
      oldPrice = isNaN(base) ? null : base;
      finalPrice = (!isNaN(base) && pct) ? base * (1 - pct / 100) : (isNaN(priceRangeRaw) ? null : priceRangeRaw);
    }

    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "2px" }}>
        {oldPrice != null && (
          <span style={{ fontSize: "0.72rem", color: "#999", textDecoration: "line-through", lineHeight: 1 }}>
            {fmt(oldPrice)} DT
          </span>
        )}
        {finalPrice != null && (
          <p className="na-price" style={{ margin: 0 }}>{fmt(finalPrice)} DT</p>
        )}
      </div>
    );
  };

  return (
    <section className="new-arrivals py-5">
      <style>{`
        /* ── DESKTOP GRID ── */
        .na-grid {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 16px;
          width: 100%;
        }
        @media (max-width: 1100px) {
          .na-grid { grid-template-columns: repeat(4, 1fr); }
        }

        .na-card {
          background: #F4F1EA;
          border-radius: 12px;
          padding: 10px;
          display: flex;
          flex-direction: column;
          align-items: center;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
          text-decoration: none;
          min-height: 220px;
        }
        .na-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 6px 20px rgba(0,0,0,0.12);
        }

        .na-img-wrap {
          width: 100%;
          height: 130px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          overflow: hidden;
          border-radius: 8px;
          background: #fff;
        }
        .na-img-wrap img {
          max-width: 90%;
          max-height: 120px;
          object-fit: contain;
          display: block;
          margin: 0 auto;
        }

        .na-promo-badge {
          position: absolute;
          top: 6px;
          right: 6px;
          background: #28a745;
          color: #fff;
          font-size: 0.6rem;
          font-weight: 700;
          padding: 2px 6px;
          border-radius: 8px;
        }

        .na-body {
          width: 100%;
          text-align: center;
          margin-top: 8px;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 4px;
          flex: 1;
        }
        .na-name {
          font-size: 0.78rem;
          font-weight: 600;
          color: #222;
          line-height: 1.3;
          margin: 0;
          word-break: break-word;
        }
        .na-price {
          font-size: 0.88rem;
          color: #ff41b4;
          font-weight: 700;
          margin: 0;
        }

        /* ── DESKTOP ARROWS ── */
        .na-arrow {
          position: absolute;
          top: 45%;
          transform: translateY(-50%);
          z-index: 10;
          background: #ff41b4;
          color: white;
          border: none;
          border-radius: 50%;
          width: 36px;
          height: 36px;
          font-size: 20px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 2px 8px rgba(0,0,0,0.15);
          transition: background 0.2s;
        }
        .na-arrow:disabled { background: #ccc; cursor: default; }

        /* ── DOTS (shared desktop + mobile) ── */
        .na-dots {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 8px;
          margin-top: 24px;
        }
        .na-dot {
          height: 8px;
          border-radius: 4px;
          border: none;
          cursor: pointer;
          padding: 0;
          transition: all 0.3s ease;
          background: #ddd;
        }
        .na-dot.active {
          width: 24px !important;
          background: #ff41b4;
        }

        /* ── MOBILE GRID ── */
        .na-mobile-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
          width: 100%;
          animation: naFadeIn 0.3s ease;
        }

        @keyframes naFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .na-mobile-card {
          background: #F4F1EA;
          border-radius: 14px;
          padding: 10px 8px;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-decoration: none;
          min-height: 190px;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }
        .na-mobile-card:active {
          transform: scale(0.97);
        }

.na-mobile-card .na-img-wrap {
  width: 100%;
  height: 110px;
  display: flex;
  align-items: center;      /* vertical center */
  justify-content: center;  /* horizontal center */
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.na-mobile-card .na-img-wrap img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 85%;
  max-height: 100px;
  object-fit: contain;
}
        .na-mobile-card .na-body {
          margin-top: 8px;
        }

        .na-mobile-card .na-name {
          font-size: 0.73rem;
        }

        .na-mobile-card .na-price {
          font-size: 0.82rem;
        }

        /* Mobile dots slightly larger touch targets */
        .na-mobile-dots .na-dot {
          height: 7px;
          min-width: 7px;
        }
        .na-mobile-dots .na-dot.active {
          width: 20px !important;
        }
      `}</style>

      <div className="container">
        {/* Section header */}
        <div className="row justify-content-center">
          <div className="col-xl-7 col-lg-9">
            <div className="section-title text-center mb-65">
              <h5 className="sub-title" style={{ fontSize: isMobile ? "16px" : "34px" }}>
                {sectionMeta?.subtitle || "New Arrivals"}
              </h5>
              <p style={{ fontSize: isMobile ? "12px" : "14px", textAlign: "center", maxWidth: "500px", margin: "auto", lineHeight: "1.5" }}>
                {sectionMeta?.description || "Explorez les derniers produits ajoutés à notre boutique."}
              </p>
            </div>
          </div>
        </div>

        {/* ── DESKTOP ── */}
        {!isMobile && (
          <div ref={carouselRef} style={{ position: "relative", padding: "0 48px" }}>
            <button className="na-arrow" style={{ left: 0 }} onClick={() => goTo(currentPage - 1)} disabled={currentPage === 0}>‹</button>

            <div className="na-grid">
              {currentProducts.map((product) => (
                <Link key={product.id} to={`/shop-details/${product.id}`} className="na-card">
                  <div className="na-img-wrap">
                    <img src={product.image} alt={product.name} />
                    {product.promo && (
                      <span className="na-promo-badge">
                        {product.promo_type === 'exact' && product.old_price && product.price_range
                          ? `-${((parsePrice(product.old_price) - parsePrice(product.price_range)) / parsePrice(product.old_price) * 100).toFixed(0)}%`
                          : product.promo_percentage ? `-${product.promo_percentage}%` : 'Promo'}
                      </span>
                    )}
                  </div>
                  <div className="na-body">
                    <p className="na-name">
                      {product.name.length > 22 ? product.name.substring(0, 22) + "…" : product.name}
                    </p>
                    {product.price_range && renderPrice(product)}
                  </div>
                </Link>
              ))}
            </div>

            <button className="na-arrow" style={{ right: 0 }} onClick={() => goTo(currentPage + 1)} disabled={currentPage >= totalPages - 1}>›</button>

            {totalPages > 1 && (
              <div className="na-dots">
                {Array.from({ length: totalPages }).map((_, i) => (
                  <button
                    key={i}
                    className={`na-dot${i === currentPage ? " active" : ""}`}
                    style={{ width: i === currentPage ? "24px" : "8px" }}
                    onClick={() => goTo(i)}
                  />
                ))}
              </div>
            )}
          </div>
        )}

        {/* ── MOBILE ── */}
        {isMobile && (
          <div ref={mobileRef}>
            <div className="na-mobile-grid">
              {mobileCurrentProducts.map((product) => (
                <Link key={product.id} to={`/shop-details/${product.id}`} className="na-mobile-card">
                  <div className="na-img-wrap">
                    <img src={product.image} alt={product.name} />
                    {product.promo && (
                      <span className="na-promo-badge">
                        {product.promo_type === 'exact' && product.old_price && product.price_range
                          ? `-${((parsePrice(product.old_price) - parsePrice(product.price_range)) / parsePrice(product.old_price) * 100).toFixed(0)}%`
                          : product.promo_percentage ? `-${product.promo_percentage}%` : 'Promo'}
                      </span>
                    )}
                  </div>
                  <div className="na-body">
                    <p className="na-name">
                      {product.name.length > 18 ? product.name.substring(0, 18) + "…" : product.name}
                    </p>
                    {product.price_range && renderPrice(product)}
                  </div>
                </Link>
              ))}
            </div>

            {mobileTotalPages > 1 && (
              <div className="na-dots na-mobile-dots">
                {Array.from({ length: mobileTotalPages }).map((_, i) => (
                  <button
                    key={i}
                    className={`na-dot${i === mobileCurrentPage ? " active" : ""}`}
                    style={{ width: i === mobileCurrentPage ? "20px" : "7px" }}
                    onClick={() => goToMobile(i)}
                  />
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </section>
  );
};
export default NewArrivals;